import { BackButton, Button, ErrorAlert, Text } from '@/components';
import { FC } from 'react';
interface Props {
  onGoogleClick: () => void;
  onTwitterClick: () => void;
  onFacebookClick: () => void;
  onEmailClick: () => void;
  onPhoneClick: () => void;
  error?: string;
}
const ContinueWithForm: FC<Props> = ({
  onGoogleClick,
  onFacebookClick,
  onTwitterClick,
  onEmailClick,
  onPhoneClick,
  error,
}) => {
  return (
    <div className="flex flex-col gap-20 w-full">
      {/* Note that opacity is set to 0, so this isn't going to be displayed.
      I'm doing this to keep the structure consistent with Sign In and
      other screens that follow from this Continue With screen. I couldn't
      figure out a better way to do this. */}
      <div className="flex flex-col gap-md opacity-0">
        <BackButton setCursorToPointer={false} />
      </div>
      <div className="flex flex-col gap-10">
        <Text value="Continue with" size="h1" />
        <div className="flex flex-col gap-md w-full">
          <div className="flex flex-col gap-md w-full">
            <Button onClick={onGoogleClick} icon="google" fullWidth alignLeft>
              Google
            </Button>
            <Button onClick={onEmailClick} icon="mail" fullWidth alignLeft>
              Email
            </Button>
          </div>
          {/* <div className="flex flex-col gap-md w-full md:flex-row lg:flex-row xl:flex-row">
            <Button onClick={onTwitterClick} icon="x" fullWidth alignLeft>
              X
            </Button>
            <Button
              onClick={onFacebookClick}
              icon="facebook"
              fullWidth
              alignLeft
            >
              Facebook
            </Button>
          </div>
          <div className="flex flex-col gap-md w-full md:flex-row lg:flex-row xl:flex-row">
            <Button onClick={onEmailClick} icon="mail" fullWidth alignLeft>
              Email
            </Button>
            <Button onClick={onPhoneClick} icon="phone" fullWidth alignLeft>
              Phone
            </Button>
          </div> */}
        </div>
        {error && (
          <ErrorAlert title="Authentication Error" description={error} />
        )}
      </div>
    </div>
  );
};
export default ContinueWithForm;
